import { render } from "./BlogDetailsTitle.vue?vue&type=template&id=05108015"
import script from "./BlogDetailsTitle.vue?vue&type=script&lang=js"
export * from "./BlogDetailsTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__